<div class="table-responsive" style="max-height: 70vh; overflow-x: auto;">
  <table class="table align-middle table-bordered fs-6 rounded-3 rounded-bottom-0 overflow-hidden m-0" style="min-width: 1200px;">
    <thead>
      <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
        <th class="text-nowrap text-center">Balance List</th>
      </tr>
    </thead>
  </table>
  <table class="table align-middle table-bordered fs-6 rounded-3 rounded-top-0 overflow-hidden m-0" style="min-width: 1200px;">
  <thead>
    <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
      <th class="text-nowrap">Date</th>
      <th class="text-nowrap">Invoice #</th>
      <th class="text-nowrap">Status</th>
      <th class="text-nowrap">Terms</th>
      <th class="text-nowrap">Invoice Amount</th>
      <th class="text-nowrap">Balance TT</th>
      <th class="text-nowrap">Total Due</th>
      <th class="text-nowrap">Allocated</th>
      <th class="text-nowrap">Balance Due</th>
      <th class="text-nowrap text-end" *ngIf="showAllocateAmount">Allocate</th>
      <th class="text-nowrap text-end">Balance Finalized Date</th>
      <!-- <th class="text-nowrap">Actions</th> -->
    </tr>
  </thead>
  <tbody class="text-gray-600 fw-semibold">
    <tr *ngIf="isLoading">
					<td colspan="20" class="text-center py-5">
						<div class="d-flex justify-content-center align-items-center">
							<span class="spinner-border spinner-border-sm me-2"></span>
							Loading invoices...
						</div>
					</td>
    </tr>
    <tr *ngIf="!isLoading && invoices.length === 0">
      <td colspan="12" class="text-center py-4">No invoices found for this client.</td>
    </tr>
    <tr *ngFor="let invoice of invoices" [class.paid-row]="invoice.is_paid">
      <td class="text-nowrap text-center">{{ invoice.invoice_date | date:'yyyy-MM-dd' }}</td>
      <td class="text-nowrap">
        <span class="invoice-clickable"
              (click)="openInvoiceModal(invoice)">
          {{ invoice.invoice_number }} [{{ invoice.vehicle?.vin_no }}]
        </span>
      </td>
      <td class="text-nowrap">{{ invoice.status | uppercase }}</td>
      <td class="text-nowrap">{{ invoice.order?.total_type || 'N/A' }}</td>
      <td class="text-nowrap">{{invoice?.item?.currency == "USD"? '$' : '¥'}} {{ invoice.invoice_amount | number:'1.0-0' }}</td>
      <td class="text-nowrap">0</td>
      <td class="text-nowrap">{{invoice?.item?.currency == "USD"? '$' : '¥'}} {{ invoice.balance | number:'1.0-0' }}</td>
      <td class="text-nowrap">
        <span class="invoice-hover-container"
             (mouseenter)="showTooltip($event, invoice)"
             (mouseleave)="hideTooltip()">
          <span class="invoice-ref-trigger">{{invoice?.item?.currency == "USD"? '$' : '¥'}} {{ invoice.paid | number:'1.0-0' }}</span>
          <div class="invoice-details-popup"  #tooltipPopup>
            <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden m-0">
              <thead>
                <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
                  <td>Allocation Date</td>
                  <td>Payment Id</td>
                  <td>Amount USD</td>
                  <td>Rate</td>
                  <td>JPY Value</td>
                </tr>
              </thead>
              <tbody class="text-gray-600 fw-semibold" *ngIf="invoice.allocations && invoice.allocations.length">
                <tr *ngFor="let allocation of invoice.allocations">
                  <td class="text-nowrap">{{ allocation.created_at | date:'yyyy-MM-dd' }}</td>
                  <td class="text-nowrap">{{ allocation.deposit_no }}</td>
                  <td class="text-nowrap">$ {{ allocation.amount_in_usd }}</td>
                  <td class="text-nowrap">{{ allocation.ex_rate }}</td>
                  <td class="text-nowrap">¥ {{ allocation.amount_in_jpy }}</td>
                </tr>
                <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
                  <td></td>
                  <td class="text-nowrap">Total Paid</td>
                  <td class="text-nowrap">$ {{ sumOfAllocations(invoice.allocations) }}</td>
                  <td class="text-nowrap">{{ averageOfRate(invoice.allocations) }}</td>
                  <td class="text-nowrap">¥ {{ sumOfAllocations(invoice.allocations,'jpy') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </span>
      </td>
      <td class="text-nowrap">{{invoice?.item?.currency == "USD"? '$' : '¥'}} {{ invoice.balance | number:'1.0-0' }}</td>
      <td class="text-nowrap text-end" *ngIf="showAllocateAmount">
        <input type="text"
               class="form-control form-control-sm w-100"
               [placeholder]="customerCurrency == 'usd' ? '$100' : '¥100'"
               [disabled]="invoice.is_paid"
               (input)="onAllocationChange(invoice._id, 'allocate_amount', $event)" />
      </td>
      <td class="text-nowrap text-end">
        <input type="date"
               class="form-control form-control-sm w-100"
               placeholder=""
               disabled="true"
               value="{{invoice.balance_finalized_date | date:'yyyy-MM-dd'}}"
               (input)="onAllocationChange(invoice._id, 'allocation_finalized_date', $event)" />
      </td>
      <!-- <td class="text-nowrap">
        <a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end">Actions
          <i class="ki-duotone ki-down fs-5 m-0"></i></a>
        <div
          class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
          data-kt-menu="true">
          <div class="menu-item px-3">
            <a href="#" class="menu-link px-3">Edit</a>
          </div>
          <div class="menu-item px-3">
            <a href="#" class="menu-link px-3">Delete</a>
          </div>
        </div>
      </td> -->
    </tr>

    <!-- Total Row -->
    <tr *ngIf="!isLoading && invoices.length > 0" class="fw-bold bg-light-primary">
      <td colspan="4" class="text-end">TOTAL:</td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ getTotalInvoiceAmount() | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{ getTotalBalanceTT() | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ getTotalDue() | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ getTotalAllocated() | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ getTotalBalanceDue() | number:'1.0-0' }}</td>
      <td class="text-nowrap" *ngIf="showAllocateAmount"></td>
      <td class="text-nowrap"></td>
    </tr>

  </tbody>
  </table>
</div>

<!-- Credit/Debit Notes Section -->
<div class="table-responsive mt-5" style="max-height: 70vh; overflow-x: auto;">
  <table class="table align-middle table-bordered fs-6 rounded-3 rounded-bottom-0 overflow-hidden m-0" style="min-width: 1200px;">
    <thead>
      <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-success-subtle">
        <th class="text-nowrap text-center">Credit/Debit Notes</th>
      </tr>
    </thead>
  </table>
  <table class="table align-middle table-bordered fs-6 rounded-3 rounded-top-0 overflow-hidden m-0" style="min-width: 1200px;">
  <thead>
    <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-success-subtle">
      <th class="text-nowrap">Date</th>
      <th class="text-nowrap">Note #</th>
      <th class="text-nowrap">Type</th>
      <th class="text-nowrap">Invoice #</th>
      <th class="text-nowrap">Amount</th>
      <th class="text-nowrap">Balance TT</th>
      <th class="text-nowrap">Total Due</th>
      <th class="text-nowrap">Allocated</th>
      <th class="text-nowrap">Balance Due</th>
      <th class="text-nowrap text-end" *ngIf="showAllocateAmount">Allocate</th>
      <th class="text-nowrap text-end">Balance Finalized Date</th>
    </tr>
  </thead>
  <tbody class="text-gray-600 fw-semibold">
    <tr *ngIf="isCreditDebitLoading">
						<td colspan="20" class="text-center py-5">
							<div class="d-flex justify-content-center align-items-center">
								<span class="spinner-border spinner-border-sm me-2"></span>
								Loading credit/debit notes...
							</div>
						</td>
    </tr>
    <tr *ngIf="!isCreditDebitLoading && creditDebitNotes.length === 0">
      <td colspan="12" class="text-center py-4">No credit/debit notes found for this client.</td>
    </tr>
    <tr *ngFor="let note of creditDebitNotes" [class.paid-row]="note.is_paid">
      <td class="text-nowrap text-center">{{ note.date | date:'yyyy-MM-dd' }}</td>
      <td class="text-nowrap">{{ note.reference_number }}</td>
      <td class="text-nowrap">
        <span [class.badge]="true"
              [class.badge-success]="note.type === 'credit'"
              [class.badge-danger]="note.type === 'debit'">
          {{ note.type | uppercase }}
        </span>
      </td>
      <td class="text-nowrap">{{ note.invoice_no || 'N/A' }}</td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ note.amount | number:'1.0-0' }}</td>
      <td class="text-nowrap">0</td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ note.balance || note.amount | number:'1.0-0' }}</td>
      <td class="text-nowrap">
        <span class="invoice-hover-container"
             (mouseenter)="showTooltip($event, note)"
             (mouseleave)="hideTooltip()">
          <span class="invoice-ref-trigger">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ note.paid || 0 | number:'1.0-0' }}</span>
          <div class="invoice-details-popup"  #tooltipPopup>
            <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden m-0">
              <thead>
                <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-success-subtle">
                  <td>Allocation Date</td>
                  <td>Payment Id</td>
                  <td>Amount USD</td>
                  <td>Rate</td>
                  <td>JPY Value</td>
                </tr>
              </thead>
              <tbody class="text-gray-600 fw-semibold" *ngIf="note.allocations && note.allocations.length">
                <tr *ngFor="let allocation of note.allocations">
                  <td class="text-nowrap">{{ allocation.created_at | date:'yyyy-MM-dd' }}</td>
                  <td class="text-nowrap">{{ allocation.deposit_no }}</td>
                  <td class="text-nowrap">$ {{ allocation.amount_in_usd }}</td>
                  <td class="text-nowrap">{{ allocation.ex_rate }}</td>
                  <td class="text-nowrap">¥ {{ allocation.amount_in_jpy }}</td>
                </tr>
                <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-success-subtle">
                  <td></td>
                  <td class="text-nowrap">Total Paid</td>
                  <td class="text-nowrap">$ {{ sumOfAllocations(note.allocations) }}</td>
                  <td class="text-nowrap">{{ averageOfRate(note.allocations) }}</td>
                  <td class="text-nowrap">¥ {{ sumOfAllocations(note.allocations,'jpy') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </span>
      </td>
      <td class="text-nowrap">{{customerCurrency == 'usd' ? '$' : '¥'}} {{ note.balance || note.amount | number:'1.0-0' }}</td>
      <td class="text-nowrap text-end" *ngIf="showAllocateAmount">
        <input type="text"
               class="form-control form-control-sm w-100"
               [placeholder]="customerCurrency == 'usd' ? '$100' : '¥100'"
               [disabled]="note.is_paid"
               (input)="onCreditDebitAllocationChange(note._id, 'allocate_amount', $event)" />
      </td>
      <td class="text-nowrap text-end">
        <input type="date"
               class="form-control form-control-sm w-100"
               placeholder=""
               disabled="true"
               value="{{note.balance_finalized_date | date:'yyyy-MM-dd'}}"
               (input)="onCreditDebitAllocationChange(note._id, 'allocation_finalized_date', $event)" />
      </td>
    </tr>

  </tbody>
  </table>
</div>

<!-- Plain Invoice Modal -->
<div class="modal fade" id="kt_modal_plain_invoice" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl" style="max-width: 90vw;">
    <div class="modal-content" style="height: 85vh;">
      <!-- Modal Header -->
      <div class="modal-header border-0 pb-0">
        <div class="d-flex align-items-center">
          <h2 class="modal-title fw-bold">Invoice Preview</h2>
        </div>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0" style="height: calc(85vh - 120px); overflow-y: auto;">
        <div class="p-4">
          <app-plain-invoice
            *ngIf="selectedInvoiceForModal"
            [invoices]="[selectedInvoiceForModal]"
            [viewMode]="'individual'">
          </app-plain-invoice>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
